/**
 * Reddit Enhancement Suite
 *
 * RES; resources scoped to reddit.com.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 5.24.10.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'kbmfpngjjgdllneeigpgjifpgocmfgmb';
export const reddiEnhancementSuite: ExtensionDefinition = {
  id: ID,
  name: "Reddit Enhancement Suite",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  requiredOrigin: 'https://www.reddit.com',
  notes: "RES; resources scoped to reddit.com.",
  signals: [
    { id: 'war-prompt-html', kind: 'web-accessible-resource',
      description: 'Fetch prompt.html, exposed only to https://www.reddit.com.',
      weight: 1, run: () => probeFetch(ID, 'prompt.html') },
    { id: 'war-prompt-entry-js', kind: 'web-accessible-resource',
      description: 'Fetch prompt.entry.js, exposed only to https://www.reddit.com.',
      weight: 0.5, run: () => probeFetch(ID, 'prompt.entry.js') },
  ],
};
